import { render, staticRenderFns } from "./RetornavelProdutoModal.vue?vue&type=template&id=db8f1e86"
import script from "./RetornavelProdutoModal.vue?vue&type=script&lang=js"
export * from "./RetornavelProdutoModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports